<template>
  <div class="card">
    <div class="card-body">
      <BRow>
        <BCol cols="12">
          <InfoAudioComponent/>
          <InfoBookComponent
              :chapters="getSortedChapters"
              :currentChapter="getCurrentChapter"
              @setCurrentChapterId="setCurrentChapter"
          />
        </BCol>
      </BRow>
    </div>
    <AudioPlayerFix
        :chapters="getSortedChapters"
        :currentChapter="getCurrentChapter"
        @setCurrentChapter="setCurrentChapter"
    />
  </div>
</template>

<script>
import InfoAudioComponent from "./info-audio/InfoAudioComponent";
import InfoBookComponent from "./info-book/InfoBookComponent";
import AudioPlayerFix from "./info-audio/AudioPlayerFix";
import * as chapterGetters from './../../../store/modules/Chapter/types/getters'
import * as chapterActions from './../../../store/modules/Chapter/types/actions'
import * as audioBookGetters from './../../../store/modules/AudioBook/types/getters'
import {mapActions, mapGetters} from "vuex";
import {eventBus} from "../../../app";
import Amplitude from 'amplitudejs';

export default {
  name: "AudioEditorComponent",
  components: {
    InfoAudioComponent,
    InfoBookComponent,
    AudioPlayerFix
  },
  data() {
    return {
      isInitialized: false,
      currentChapterId: null,
      audio: {
        songs: []
      }
    };
  },

  computed: {
    ...mapGetters('AudioBook', {
      audioBook: audioBookGetters.GET_AUDIO_BOOK
    }),
    ...mapGetters('Chapter', {
      chapters: chapterGetters.GET_CHAPTERS,
    }),
    getSortedChapters() {
      return this.toGetSortedChapters();
    },
    getCurrentChapter() {
      return this.currentChapterId
          ? this.chapters[this.currentChapterId]
          : this.chapters[_.findKey(this.chapters, obj => obj.index === 0)];
    },
  },
  methods: {
    ...mapActions('Chapter', {
      getChapters: chapterActions.GET_CHAPTERS
    }),
    toGetSortedChapters() {
      return _.sortBy(_.values(this.chapters), 'index');
    },
    getInitAmplitude() {
      return {
        songs: _.map(this.toGetSortedChapters(), obj => {
          return {
            url: obj.link,
          }
        }),
        continue_next: false,
        callbacks: {
          stop: function () {
            eventBus.$emit('changePlayerStatus', 'stopped');
          },
          play: function () {
            eventBus.$emit('changePlayerStatus', 'playing');
          },
          pause: function () {
            eventBus.$emit('changePlayerStatus', 'paused');
          }
        }
      }
    },
    setCurrentChapter(chapterId) {
      this.currentChapterId = chapterId;
      if (this.isInitialized) {
        this.setCurrentAudioTrack();
        this.setCurrentRoute();
      }
    },
    setCurrentRoute() {
      this.$router.push({
        name: 'AudioEditor', params: {
          id: this.$route.params.id,
          chapterId: this.currentChapterId
        }
      })
    },
    async setCurrentAudioTrack() {
      await Amplitude.skipTo(0, this.getCurrentAudioIndex())
      await Amplitude.stop();
    },
    getCurrentAudioIndex() {
      let idx = _.findIndex(this.toGetSortedChapters(), chapter => {
        return chapter.id === parseInt(this.currentChapterId, 10)
      })
      return idx === -1 ? 0 : idx;
    },
    audioBookInitialize() {
      try {
        if (this.audioBook && this.audioBook.id) {
          this.getChapters(this.audioBook.id).then(() => {
            Amplitude.init(this.getInitAmplitude());
            this.setCurrentAudioTrack();
            this.isInitialized = true;
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    "audioBook": {
      handler: function () {
        this.audioBookInitialize()
      }
    }
  }
}
</script>